module.exports = __webpack_public_path__ + "static/mic-464d033b9435facc7681d52e6faefeff.jpeg";